import styled from '@emotion/styled';
import { StyledEditor } from '@rocketseat/gatsby-theme-docs/src/components/Code/styles';

export const ComponentLibraryStyledEditor = styled(StyledEditor)`
    border-radius: 4px;
    margin-bottom: 1rem;
`;

export const ComponentLibraryCodeOutputWrapper = styled.div`
    max-width: 50%;
    margin-bottom: 1rem;
`;

export default { ComponentLibraryStyledEditor, ComponentLibraryCodeOutputWrapper };